import React, { useState, useEffect } from "react";
import { Image } from "antd";
import columns from "../../../columns/ib/Promotion.js";
import TableWithSkeleton from "../../../components/table/TableWithSkeleton.jsx";
import Pagination from "../../../components/pagination/Pagination.jsx";
import { GetAllPromotionKitApi } from "../../../api/request/ib/ibpromotion.js";
import moment from "moment/moment.js";
import { useSelector } from "react-redux";
import Copy from "../../../components/copy/Copy.jsx";

export default function Kyc() {
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const { userDetails } = useSelector(state => state.user);

  const getAllpromotion = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        FilterText: "Active"
      }
      setIsLoading(true);
      const { data } = await GetAllPromotionKitApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              url: (<div className="h-[50px] w-[50px] overflow-hidden">
                <Image src={item?.url} fallback='/assets/images/promotion-placeholder.png' className="object-cover w-full h-full" alt="img" />
              </div>),
              actions: (<Copy text={copyIframe(item)} />),
              createdDate: item?.createdDate ? moment(item?.createdDate).format('DD-MM-YYYY, hh:mm A') : null,
            };
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  }

  const copyIframe = (item) => {
    return `<a href="https://client.capitalfxglobal.com/?tab=register&ref=${userDetails.referralCode}">
        <iframe src="http://localhost:3001/promotionKit/${item?.id}?ref=${userDetails.referralCode}" width="${item.width}" height="${item.height}" style="border:none;"></iframe>
    </a>`
  }

  useEffect(() => {
    getAllpromotion();
  }, [page, pageSize]);

  return (
    <div>
      <div className="border border-gray-200 rounded-xl">
        <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
      </div>
      <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
    </div>
  );
}
